<template>
  <div>
    <!-- {{ statusList }} -->

    <h4 class="mr-sm-4 mb-3 header-tablepage">นับสต๊อก</h4>
    <b-tabs content-class="py-3" v-model="tabIndex">
      <b-tab
        v-for="status of statusList"
        :key="status.id"
        :value="status.id"
        @click="onTabChange(status.id, $event)"
      >
        <template #title>
          {{ status.name_th }}
          <b-badge pill>
            {{ status.count }}
            <span class="sr-only">count items list</span></b-badge
          >
        </template>
        <div class="d-flex justify-content-between">
          <InputText
            v-model="filter.search"
            type="text"
            faIcon="search"
            className="mb-2 bg-second w-50"
            placeholder="ค้นหาลูกค้า"
            @onClickIcon="onSearch"
            textField="telephone"
            @onEnter="onSearch"
          />
          <b-button class="bg-main bt-height" @click="showModalStock">
            <font-awesome-icon icon="plus" class="mr-0 mr-sm-1" />
            สร้าง
          </b-button>
        </div>
        <b-table
          striped
          hover
          :busy="isBusy"
          :items="items"
          :fields="fields"
          show-empty
          empty-text="No matching records found"
        >
          <template v-slot:cell(document_no)="data">
            {{ data.item.document_no || "-" }}
          </template>
          <template v-slot:cell(remark)="data">
            {{ data.item.stock_surplus }} / {{ data.item.stock_deficit }}
          </template>
          <template v-slot:cell(status)="{ item }">
            <div
              :class="{
                'text-warning': item.status == 2,
                'text-danger': item.status == 5,
                'text-success': item.status == 3 || item.status == 4,
                'text-info':
                  item.status == 7 || item.status == 1 || item.status == 0,
              }"
            >
              {{ getStatusName(item.status) || "-" }}
            </div>
          </template>
          <template v-slot:cell(set_stock_time)="data">
            <div
              class="text-center text-black my-2"
              v-if="data.item.set_stock_time"
            >
              {{ $moment(data.item.set_stock_time).format("DD/MM/YYYY") }}
              <br />
              <small>{{
                $moment(data.item.set_stock_time).format("HH:mm")
              }}</small>
            </div>
            <div v-else>-</div>
          </template>
          <template v-slot:cell(stock_type_id)="data">
            <div
              class="text-center text-black my-2"
              v-if="data.item.stock_type_id"
            ></div>
            <div v-else>-</div>
          </template>
          <template v-slot:cell(sales_name)="data">
            {{ data.item.sales_name || "-" }}
          </template>
          <template v-slot:cell(approved_time)="data">
            <div
              class="text-center text-black my-2"
              v-if="data.item.approved_time"
            >
              {{ $moment(data.item.approved_time).format("DD/MM/YYYY") }}
              <br />
              <small>{{
                $moment(data.item.approved_time).format("HH:mm")
              }}</small>
            </div>
            <div v-else>-</div>
          </template>
          <template v-slot:cell(stock_surplus)="data">
            <div
              v-if="
                data.item.stock_surplus == 0 && data.item.stock_deficit == 0
              "
            >
              -
            </div>
            <div
              v-else
              :class="{
                'text-danger':
                  data.item.stock_surplus < data.item.stock_deficit,
                'text-success':
                  data.item.stock_surplus == data.item.stock_deficit,
                'text-warning':
                  data.item.stock_surplus > data.item.stock_deficit,
              }"
            >
              {{ data.item.stock_surplus | numeral("0,0") }}/{{
                data.item.stock_deficit | numeral("0,0")
              }}
            </div>
          </template>

          <template v-slot:cell(action)="data">
            <div class="d-flex align-items-center justify-content-center">
              <font-awesome-icon
                icon="search"
                title="detail"
                class="ml-2 color-primary pointer"
                @click="$router.push('/inventory-check/detail/' + data.item.id)"
              />
            </div>
          </template>

          <template v-slot:table-busy>
            <div class="text-center text-black my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="ml-2">Loading...</strong>
            </div>
          </template>
        </b-table>
        <Pagination
          @handleChangeTake="handleChangeTake"
          :pageOptions="pageOptions"
          :filter="filter"
          :rows="rows"
          @pagination="pagination"
        />
      </b-tab>
    </b-tabs>

    <ModalStock ref="modalStock" @submit="submit" />
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import InputText from "@/components/inputs/InputText";
import ModalStock from "./components/ModalStock";
import { mapGetters } from "vuex";
export default {
  components: {
    Pagination,
    InputText,
    ModalStock,
  },
  data() {
    return {
      filter: {
        search: "",
        inventory_transfer_document_id: this.$route.params.id,
        branch_id: this.branchId,
        page: 1,
        take: 10,
      },
      pageOptions: [
        { value: 5, text: "5 / page" },
        { value: 10, text: "10 / page" },
        { value: 30, text: "30 / page" },
        { value: 50, text: "50 / page" },
        { value: 100, text: "100 / page" },
      ],
      rows: 0,
      statusList: [],
      items: [],
      fields: [
        { label: "หมายเลข", key: "inventory_check_no" },
        { label: "คลัง", key: "sum_inventory_stock" },
        { label: "วันที่สต๊อก", key: "set_stock_time" },
        {
          label: "พนักงาน",
          key: "sales_name",
        },
        {
          label: "วันที่เสร็จ",
          key: "approved_time",
        },
        { label: "เกิน/ขาด", key: "stock_surplus" },
        { label: "สถานะ", key: "status" },
        { label: "", key: "action" },
      ],
      tabIndex: 1,
      isBusy: false,
      isLoading: false,
      fieldsDetail: [
        { label: "#", key: "" },
        { label: "Product", key: "product_name" },
        { label: "Quantity", key: "quantity" },
      ],
      modalCallBack: () => {},
      modalMessage: "",
      form: {},
    };
  },
  watch: {
    tabIndex(val) {},
  },
  created() {
    this.getStatusList();
  },
  computed: {
    ...mapGetters({
      branchId: "getBranchId",
    }),
  },
  methods: {
    async getData() {
      this.isBusy = true;

      const res = await this.axios.post(
        `${this.$baseUrl}/inventorycheck/get-all`,
        this.filter
      );

      this.rows = res.detail.total;
      this.items = res.detail.data;
      this.isBusy = false;
    },

    async getStatusList(flag = true) {
      const res = await this.axios(
        `${this.$baseUrl}/inventorycheck/get-count/by-branch-id/${this.branchId}`
      );
      this.filter.branch_id = this.branchId;
      if (flag) this.filter.status = res.detail[0].id;
      this.getData();
      this.statusList = res.detail;
    },

    handleChangeTake(val) {
      this.filter.take = val;
      this.filter.page = 1;
      this.getData();
    },
    pagination(val) {
      this.filter.page = val;
      this.getData();
    },
    onSearch() {
      this.getData();
    },
    onTabChange(val, e) {
      this.filter.status = val;
      this.filter.page = 1;
      this.getData(val);
    },

    showModalStock() {
      // this.$refs.modalStock.show();
      this.submit();
    },
    async submit(list) {
      await this.$store.dispatch("setMainLoading", true);
      const res = await this.axios.post(
        `${this.$baseUrl}/inventorycheck/create`,
        {
          branch_id: this.branchId,
          // stock_type_ids: [],
          sales_no: this.$cookies.get("saleId"),
        }
      );
      await this.$store.dispatch("setMainLoading", false);
      if (res.result)
        await this.successAlert(),
          this.$router.push("/inventory-check/detail/" + res.detail);
      else this.errorAlert(res.message);
    },
    getStatusName(id) {
      id = id == 0 ? 1 : id;
      return this.statusList.find((el) => el.id == id).name_th;
    },
  },
};
</script>

<style lang="scss" scoped>
.bt-height {
  height: 35px !important;
}
.header-tablepage {
  color: var(--primary-color) !important;
  font-weight: bold;
  font-size: 20px;
  text-transform: uppercase;
}
</style>
